import React from "react";
import HTMLParser from "../../htmlParser";
const ExternalContent = (props) => {
    if (!props.innerBlocks[0] ||
        !props.innerBlocks[0].outerHTML.length ||
        props.innerBlocks[0].name !== "core/html") {
        return React.createElement(React.Fragment, null);
    }
    const isVideo = typeof props.attributes.isVideo !== "undefined" &&
        props.attributes.isVideo === true;
    const hasTranscript = typeof props.attributes.haveTranscript !== "undefined" &&
        props.attributes.haveTranscript === true &&
        props.attributes.transcript &&
        props.attributes.transcript.length &&
        props.attributes.transcript.replace(/(<([^>]+)>)/gi, "").trim().length;
    const hasDescription = typeof props.attributes.description !== "undefined" &&
        props.attributes.description &&
        props.attributes.description.length &&
        props.attributes.description.replace(/(<([^>]+)>)/gi, "").trim().length;
    return (React.createElement("div", { className: "wp-gco-external", "data-video": isVideo, "data-transcript": isVideo && hasTranscript },
        React.createElement(HTMLParser, null, props.innerBlocks[0].outerHTML),
        hasDescription ? (React.createElement("div", { className: "definition" },
            React.createElement(HTMLParser, null, props.attributes.description))) : (React.createElement(React.Fragment, null)),
        isVideo && hasTranscript ? (React.createElement("div", { className: "transcript" },
            React.createElement(HTMLParser, null, props.attributes.transcript))) : (React.createElement(React.Fragment, null))));
};
export default ExternalContent;
